import CountryService from '@/services/logistics/CountryService';

export default class FindCountryByIso {
    /**
     * Find country by iso.
     *
     * @param {String} iso
     *
     * @returns {Object}
     */
    handle(iso) {
        let countries = CountryService.getCountries();

        return countries.find(country => country.iso === iso);
    }
}
